import { makeStyles } from '@rbx/ui';

const useCoursesStyles = makeStyles()((theme) => ({
  container: {
    margin: '0 auto',
    padding: '32px',
    height: '100vh',
    overflowY: 'auto',
    [theme.breakpoints.down('Large')]: {
      padding: '16px',
    },
  },
  newLayoutWrapper: {
    display: 'flex',
    alignItems: 'stretch',
    flexDirection: 'column',
    width: '100%',
  },
  wrapper: {
    display: 'flex',
    alignItems: 'stretch',
    flexDirection: 'column',
    width: '100%',
    padding: '0',
  },
  content: {
    flex: 1,
    padding: '0 24px',
    [theme.breakpoints.down('Large')]: {
      padding: '16px',
    },
    [theme.breakpoints.down('Medium')]: {
      padding: '0',
    },
  },
  coursesGrid: {
    display: 'grid',
    gap: '24px',
    justifyContent: 'center',
    gridTemplateColumns: '1fr',
    marginTop: '24px',
    [theme.breakpoints.down('Medium')]: {
      gridTemplateColumns: 'repeat(2, 1fr)',
      gap: '24px',
      maxWidth: '560px',
      margin: '24px auto 0',
      padding: '0 24px',
    },
    [theme.breakpoints.down(580)]: {
      gridTemplateColumns: '1fr',
      maxWidth: '256px',
      padding: '0 24px',
    },
  },
  lessonNavigation: {
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',
    marginBottom: '24px',
    paddingTop: '16px',
    [theme.breakpoints.down('Medium')]: {
      justifyContent: 'center',
      width: '100%',
    },
  },
  lessonNavigationText: {
    display: 'flex',
    alignItems: 'center',
    gap: '16px',
  },
  oldLayoutLessonTitle: {
    marginTop: '0',
    alignItems: 'center',
    paddingBottom: '40px',
    justifyContent: 'space-between',
  },
  coursesHomeHeader: {
    display: 'flex',
    flexDirection: 'row',
    alignItems: 'center',
    justifyContent: 'space-between',
    padding: '0',
    maxWidth: '892px',
    margin: '0 auto',
    [theme.breakpoints.down('Medium')]: {
      maxWidth: '600px',
    },
    [theme.breakpoints.down(580)]: {
      maxWidth: '256px',
    },
    [theme.breakpoints.down('XSmall')]: {
      flexDirection: 'column',
      alignItems: 'flex-start',
      gap: '16px',
    },
  },
  coursesHomeHeaderOldLayout: {
    marginTop: '24px',
  },
  lessonContentContainer: {
    margin: '0 auto',
    padding: '0 101px',
    [theme.breakpoints.down('Large')]: {
      padding: '0 16px',
    },
    [theme.breakpoints.down('Medium')]: {
      padding: '0 12px',
      paddingBottom: '48px',
    },
  },
  newLayoutContainer: {
    maxWidth: '1200px',
    width: '100%',
    margin: '0 auto',
    padding: '0 32px',
    [theme.breakpoints.down('Large')]: {
      padding: '16px',
    },
  },
  lessonNavigationButton: {
    [theme.breakpoints.down('Medium')]: {
      width: '100%',
    },
  },
  lessonNavigationLink: {
    textDecoration: 'none',
    display: 'block',
    width: '100%',
  },
}));

export default useCoursesStyles;
